import TwoDimensionalImage from './components/TwoDimensionalImage/TwoDimensionalImage.jsx';

export {
	TwoDimensionalImage,
};
